<template>
  <main class="app-container">
    <div class="course-show" v-if="course.id">
      <div class="ch-header-paper">
        <div class="top"><h3>{{course.age_start}}岁 - {{course.age_end}}岁 {{course.season}}</h3></div>
        <div class="bottom"></div>
      </div>

      <div class="content">
        <h3 class="main-title">关于课程</h3>
        <div class="brief">
          <p>课程编号：{{course.no}}</p>
          <p>课程类型：{{course.type_text}}</p>
          <p><b>{{date(course.start_day)}} - {{date(course.end_day)}}</b></p>
          <p>{{course.week_day_text}}</p>
          <p>{{course.start_time}} - {{course.end_time}}</p>
          <p class="fz14"><span class="text-orange" @click="collapseShow('dates')" v-text="collapse.dates ? '隐藏日程' : '查看日程'"></span></p>
          <div class="dates" v-show="collapse.dates">
            <p v-for="item in course.days">{{date(item)}} {{weekDay(course.week_day)}}</p>
          </div>
          <hr>
          <div class="address text-orange" @click="openLocation">
            <md-icon name="location" /> {{course.place}}，{{course.city}}
          </div>
          <hr>
          <div class="leader">
            <img :src="course.leader.avatar" />
            <div class="info">
              <h4>课程Leader</h4>
              <p class="text-orange" @click="toLeader(course.leader.id)">{{course.leader.name}}</p>
            </div>
          </div>
          <hr>
          <div class="price">
            <p>单次活动价：<b class="text-orange">￥{{course.price}}/人</b></p>

            <!--<span class="help">剩余{{course.left}}次活动</span>-->
          </div>
          <!--<template v-if="course.can_trial_enroll">-->
            <!--<hr>-->
            <!--<div class="price">-->
              <!--<p>体验价：<b class="text-orange">￥{{course.trial_price}}/人</b></p>-->
              <!--<span class="help" v-if="course.min_qty == 1">仅可参加一次活动</span>-->
              <!--<span class="help" v-else>仅可参加一次活动，至少需要{{course.min_qty}}名儿童报名</span>-->
            <!--</div>-->
          <!--</template>-->
          <!--<template v-if="course.single_price">-->
            <!--<hr>-->
            <!--<div class="price">-->
              <!--<p>单次活动价：<b class="text-orange">￥{{course.single_price}}/人</b></p>-->
              <!--&lt;!&ndash;<span class="help">仅可参加一次活动</span>&ndash;&gt;-->
            <!--</div>-->
          <!--</template>-->
          <hr class="mb0">
        </div>
      </div><!-- E .content -->

        <md-tabs @change="tabChange">
          <md-tab-pane name="p1" label="活动介绍">
            <div class="content mt10">
              <div class="rich-text" v-html="course.content"></div>
              <hr>
              <h3 class="title">温馨提示</h3>
              <div class="rich-text" v-html="tips"></div>
              <h3 class="title">退改政策</h3>
              <div class="rich-text" v-html="refund"></div>
            </div>
          </md-tab-pane>
          <md-tab-pane name="p2" label="活动点评">
            <div class="content">
              <list-loading v-show="reviewsLoading" />

              <div class="no-result" v-show="!reviewsLoading && reviews.length < 1">暂无数据</div>

              <review-item :review="item" v-for="item in reviews" :key="item.id" />
            </div>
          </md-tab-pane>
          <md-tab-pane name="p3" label="已报名">
            <div class="content">
              <list-loading v-show="enrollsLoading" />

              <div class="no-result" v-show="!enrollsLoading && enrolls.length < 1">暂无数据</div>
              <md-field>
                <md-cell-item v-for="(item, index) in enrolls" :key="index" :title="item.nickname" :addon="item.enrolled_at" />
              </md-field>
            </div>
          </md-tab-pane>
        </md-tabs>




      <enroll-bar v-show="isPreview == false"
              :course="course"
      />
    </div>


  </main>
</template>

<script>
import {Icon,Tabs, TabPane, Field, CellItem} from 'mand-mobile'
import EnrollBar from "../components/EnrollBar.vue";
import ReviewItem from "../components/ReviewItem.vue";
import ListLoading from "../components/ListLoading.vue";
import moment from 'moment'
import WechatSdk from "../untils/wechat-sdk";
import { mapState } from 'vuex'

export default {

  components: {
      [Icon.name]:Icon,
      [Tabs.name]:Tabs,
      [TabPane.name]:TabPane,
      [Field.name]:Field,
      [CellItem.name]:CellItem,
      EnrollBar,ReviewItem,ListLoading,
  },
  data() {
    return {
        _id:null,
        loading:true,
        collapse:{overview:true,review:true,dates:false},
        course:{id:null,packages:[]},
        isPreview:false,
        reviews: [],
        reviewsLoading: true,
        enrolls: [],
        enrollsLoading: true,
        reviewLoadStatus:'init',
        enrollLoadStatus:'init',
    }
  },
    computed: {
        ...mapState({
            tips: state => state.courseTerms.tips,
            refund: state => state.courseTerms.refund
        })
    },
  created() {
//    console.log('mounted');
//    document.querySelector('body').className = "bg-milk";
      console.log(this.$route);
      const {id} = this.$route.params;
//      this.isPreview = this.$route.name == 'activity-preview';
      if(id) {
          this._id = id;
          this.loadData(id);
          this.$store.dispatch('courseTerms/load');
      }


  },
  methods: {
      collapseShow(key) {
          this.collapse[key] = !this.collapse[key];
      },
      loadData(id) {
          this.$toast.loading("加载中...");
          this.$http.get(`courses/${id}`)
              .then(({data}) => {
                this.$toast.hide();
                this.course = data;
//                this.loadReviews(id);
                this.setShareData();
              })
              .catch(err => {
                console.log(err);
                  //setTimeout(() => this.$toast.failed("课程不存在"), 300);
              });
      },
      tabChange(tab) {
          console.log(tab);
          if(tab.name == 'p2' && this.reviewLoadStatus == 'init') {
              this.reviewLoadStatus = 'loading';
              this.loadReviews(this._id);
          } else if(tab.name == 'p3' && this.enrollLoadStatus == 'init') {
              this.enrollLoadStatus = 'loading';
              this.loadEnrolls(this._id)
          }
      },
      loadReviews(id) {
          this.$http.get(`reviews`, {params:{course_id:id}})
              .then(({data}) => {
                  this.reviews = data;
                  this.reviewsLoading = false;
              })
              .catch(err => {
                  this.reviewsLoading = false;
              });
      },
      loadEnrolls(id) {
          this.$http.get(`courses/${id}/enrolls`)
              .then(({data}) => {
                  this.enrolls = data;
                  this.enrollsLoading = false;
              })
              .catch(err => {
                  this.enrollsLoading = false;
              });
      },
      date(day) {
          return moment(day).format("MM月DD日");
      },
      weekDay(day) {
          const week = ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
          return week[day] ? week[day] : '---';
      },
      toLeader(leaderId) {
          this.$router.push({name:'leaders-show', params:{id:leaderId}});
      },
      openLocation() {
          wx.openLocation({
              latitude: this.course.lat, // 纬度，浮点数，范围为90 ~ -90
              longitude: this.course.lng, // 经度，浮点数，范围为180 ~ -180。
              name: this.course.place, // 位置名
              address: '', // 地址详情说明
              scale: 12, // 地图缩放级别,整形值,范围从1~28。默认为最大
              infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
          });
      },
      setShareData() {
          const logo = "http://tofino.oss-cn-chengdu.aliyuncs.com/logo.png";
          WechatSdk.updateAppMessageShareData({
              title: 'Wondergarten 出来玩', // 分享标题
              desc: this.course.place + '的活动', // 分享描述
              link: window.location.origin + this.$route.fullPath,
              imgUrl: this.course.leader.avatar, // 分享图标
          });
          WechatSdk.updateTimelineShareData({
              title: 'Wondergarten 出来玩 ' + this.course.place + '的活动', // 分享标题
              link: window.location.origin + this.$route.fullPath,
              imgUrl: this.course.leader.avatar, // 分享图标
          });
      },
  }
}

</script>

<style lang="scss" scoped>
.course-show {
  hr {
    border: 0;
    border-top: 1px solid #dfdcd4;
    margin-top: 30px;
    margin-bottom: 30px;
  }



  .content {
    padding: 0 20px 20px;

    .main-title {
      font-size: 60px;
      font-weight:700;
      margin-top: 40px;
      margin-bottom: 20px;
    }

    .brief {
      padding: 20px 20px 0 20px;

      p {
        font-size: 32px;
        line-height: 1.6;
      }
      .dates {
        p {font-size: 28px;}
      }


      .price {
        .help{
          display: inline-block;
          font-size: 28px;
          color: #afafaf;
          margin-top:12px;
        }
      }
      .leader {
        display: flex;

        img {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          margin-right: 20px;
        }

        p {
          margin-top: 10px;
        }
      }
    }
    h3.title{
      margin: 20px 0;
      font-weight: normal;
    }
  }

  .collapse-tab {
    .head {
      /*padding: 0 0 30px;*/
      font-size: 40px;

      color: #5dbebc;
      line-height: 50px;
      .md-icon {
        font-weight:bold;
        margin-right: 10px;
      }
    }

    .title {
      font-weight: 600;
      font-size: 40px;
      margin-top: 75px;
      margin-bottom: 20px;
    }
  }

  .rich-text{
    line-height: 1.5;
  }

}

</style>

